document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll("[data-ew-accordion]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const stopAnim = (el) => {
    if (!el) return;
    el.getAnimations?.().forEach((a) => a.cancel());
  };

  const preloadImage = async (src) => {
    if (!src) return;
    const pre = new Image();
    pre.src = src;

    // decode быстрее, но может падать — делаем fallback на load/error
    if (pre.decode) {
      try { await pre.decode(); return; } catch (e) {}
    }

    await new Promise((res) => {
      pre.addEventListener("load", res, { once: true });
      pre.addEventListener("error", res, { once: true });
    });
  };

  const animatePanelOpen = (panel) => {
    if (!panel) return Promise.resolve();
    stopAnim(panel);

    panel.hidden = false;

    const endH = panel.scrollHeight;
    panel.style.overflow = "hidden";
    panel.style.height = "0px";

    const anim = panel.animate(
      [{ height: "0px", opacity: 0 }, { height: `${endH}px`, opacity: 1 }],
      { duration: 360, easing: "cubic-bezier(.2,.8,.2,1)" }
    );

    const cleanup = () => {
      panel.style.height = "";
      panel.style.overflow = "";
    };
    anim.onfinish = cleanup;
    anim.oncancel = cleanup;

    return anim.finished.catch(() => {});
  };

  const animatePanelClose = (panel) => {
    if (!panel || panel.hidden) return Promise.resolve();
    stopAnim(panel);

    const startH = panel.scrollHeight;
    panel.style.overflow = "hidden";
    panel.style.height = `${startH}px`;

    const anim = panel.animate(
      [{ height: `${startH}px`, opacity: 1 }, { height: "0px", opacity: 0 }],
      { duration: 300, easing: "cubic-bezier(.4,0,.2,1)" }
    );

    const cleanup = () => {
      panel.hidden = true;
      panel.style.height = "";
      panel.style.overflow = "";
    };
    anim.onfinish = cleanup;
    anim.oncancel = cleanup;

    return anim.finished.catch(() => {});
  };

  accordions.forEach((acc) => {
    // ✅ защита от двойной инициализации (важно в theme editor и при повторном подключении)
    if (acc.dataset.ewAccordionInit === "1") return;
    acc.dataset.ewAccordionInit = "1";

    const items = Array.from(acc.querySelectorAll("[data-ew-accordion-item]"));
    const root = acc.closest(".ew-coaching") || acc;
    const img = root.querySelector("[data-ew-accordion-image]");

    if (!items.length) return;

    let actionId = 0;

    const getParts = (item) => ({
      trigger: item.querySelector(".ew-accordion__trigger"),
      panel: item.querySelector(".ew-accordion__panel"),
      mark: item.querySelector(".ew-accordion__mark"),
      image: (item.dataset.image || "").trim()
    });

    const fadeSwapImage = async (nextSrc, token) => {
      if (!img || !nextSrc) return;

      const current = img.getAttribute("src") || "";
      if (current === nextSrc) return;

      // ✅ сначала прелоадим новую картинку (не трогаем DOM пока не готово)
      await preloadImage(nextSrc);
      if (token !== actionId) return; // кто-то уже кликнул дальше

      if (reduceMotion) {
        img.src = nextSrc;
        return;
      }

      stopAnim(img);

      // fade out
      const out = img.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 220,
        easing: "ease-out",
        fill: "forwards"
      });

      await out.finished.catch(() => {});
      if (token !== actionId) return;

      // swap
      stopAnim(img);
      img.style.opacity = "0";
      img.src = nextSrc;

      // ✅ ждём decode уже у элемента (чтобы исключить "подтянулась позже")
      if (img.decode) {
        try { await img.decode(); } catch (e) {}
      } else {
        await new Promise((res) => {
          img.addEventListener("load", res, { once: true });
          img.addEventListener("error", res, { once: true });
        });
      }
      if (token !== actionId) return;

      // fade in
      const inn = img.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 260,
        easing: "ease-out",
        fill: "forwards"
      });

      await inn.finished.catch(() => {});
      if (token !== actionId) return;

      img.style.opacity = "";
    };

    const setActive = async (nextItem, { immediate = false } = {}) => {
      actionId += 1;
      const token = actionId;

      const anims = [];

      items.forEach((it) => {
        const { trigger, panel, mark } = getParts(it);
        const isActive = it === nextItem;

        it.classList.toggle("is-active", isActive);
        if (trigger) trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
        if (mark) mark.textContent = isActive ? "−" : "+";

        if (!panel) return;

        if (immediate || reduceMotion) {
          stopAnim(panel);
          panel.hidden = !isActive;
          panel.style.height = "";
          panel.style.overflow = "";
        } else {
          if (isActive) anims.push(animatePanelOpen(panel));
          else anims.push(animatePanelClose(panel));
        }
      });

      if (!immediate && !reduceMotion) {
        await Promise.allSettled(anims);
      }
      if (token !== actionId) return;

      const { image } = getParts(nextItem);

      if (immediate || reduceMotion) {
        if (img && image) img.src = image;
        return;
      }

      await fadeSwapImage(image, token);
    };

    // init
    setActive(items[0], { immediate: true });

    // clicks
    items.forEach((item) => {
      const { trigger } = getParts(item);
      if (!trigger) return;

      trigger.addEventListener("click", () => {
        if (item.classList.contains("is-active")) return;
        setActive(item);
      });
    });
  });
});

(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll(".ew-faq").forEach((faq) => {
    const items = Array.from(faq.querySelectorAll(".ew-faq__item"));
    if (!items.length) return;

    let actionId = 0;

    const getParts = (item) => ({
      btn: item.querySelector(".ew-faq__question"),
      answer: item.querySelector(".ew-faq__answer"),
    });

    const stopAnim = (el) => {
      if (!el) return;
      el.getAnimations?.().forEach((a) => a.cancel());
    };

    const openAnswer = (answer) => {
      if (!answer) return Promise.resolve();
      stopAnim(answer);

      answer.hidden = false;

      const endH = answer.scrollHeight;
      answer.style.overflow = "hidden";
      answer.style.height = "0px";

      const anim = answer.animate(
        [{ height: "0px", opacity: 0 }, { height: `${endH}px`, opacity: 1 }],
        { duration: 340, easing: "cubic-bezier(.2,.8,.2,1)" }
      );

      const cleanup = () => {
        answer.style.height = "";
        answer.style.overflow = "";
      };

      anim.onfinish = cleanup;
      anim.oncancel = cleanup;

      return anim.finished.catch(() => {});
    };

    const closeAnswer = (answer) => {
      if (!answer || answer.hidden) return Promise.resolve();
      stopAnim(answer);

      const startH = answer.scrollHeight;
      answer.style.overflow = "hidden";
      answer.style.height = `${startH}px`;

      const anim = answer.animate(
        [{ height: `${startH}px`, opacity: 1 }, { height: "0px", opacity: 0 }],
        { duration: 280, easing: "cubic-bezier(.4,0,.2,1)" }
      );

      const cleanup = () => {
        answer.hidden = true;
        answer.style.height = "";
        answer.style.overflow = "";
      };

      anim.onfinish = cleanup;
      anim.oncancel = cleanup;

      return anim.finished.catch(() => {});
    };

    const setActive = async (nextIndex, { immediate = false } = {}) => {
      actionId += 1;
      const myAction = actionId;

      const anims = [];

      items.forEach((item, idx) => {
        const { btn, answer } = getParts(item);
        const isActive = idx === nextIndex;

        item.classList.toggle("is-active", isActive);

        // accessibility (без правок HTML)
        if (btn) {
          btn.setAttribute("aria-expanded", isActive ? "true" : "false");
          // связываем с answer, если id нет — создадим
          if (!btn.id) btn.id = `ew-faq-q-${idx + 1}-${Math.random().toString(16).slice(2)}`;
        }

        if (answer) {
          if (!answer.id) answer.id = `ew-faq-a-${idx + 1}-${Math.random().toString(16).slice(2)}`;
          if (btn) btn.setAttribute("aria-controls", answer.id);

          if (immediate || reduceMotion) {
            answer.hidden = !isActive;
            answer.style.height = "";
            answer.style.overflow = "";
            stopAnim(answer);
          } else {
            if (isActive) anims.push(openAnswer(answer));
            else anims.push(closeAnswer(answer));
          }
        }
      });

      if (!immediate && !reduceMotion) {
        await Promise.allSettled(anims);
      }

      if (myAction !== actionId) return;
    };

    // init: первый открыт
    setActive(0, { immediate: true });

    // clicks
    items.forEach((item, idx) => {
      const { btn } = getParts(item);
      if (!btn) return;

      btn.addEventListener("click", () => {
        // как у тебя: один всегда открыт (клик по активному — ничего не делает)
        if (item.classList.contains("is-active")) return;
        setActive(idx);
      });
    });
  });
})();